
import { component } from '@/helpers/vueTyped';

export default component()({
  name: 'HighlightSectionGhostLoader',

  functional: true,

  render() {
    return (
      <div class='highlight-section-container' key='loader'>
        <span class='category-logo-container'>
          <div class='category-logo' />
          <div class='category-name' />
        </span>
        <div class='item-name' />
        <span class='item-date-container'>
          <div class='item-date-pipe' />
          <div class='item-date' />
        </span>
      </div>
      );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-a9f4439c/HighlightSectionGhostLoader.vue" });